import React from "react";
import RouteList from "Routes/private/list";
import { Menu } from "antd";
import { Link, useHistory } from "react-router-dom";
import { useStoreState } from "easy-peasy";
import { AuthCheck, AUTH_ACTIONS } from "authorization";

const { SubMenu } = Menu;

export default function ParameterNavigation({ onCollapseSider, ...props }) {
  const history = useHistory();
  const { abilities } = useStoreState((store) => store.auth);

  const root = RouteList[0].children.find((f) => f.name === "Parametreler");
  const routes = root.children || [];
  const path = "/panel/parametreler";

  const renderMenuItem = (item, path) => {
    if (!AuthCheck(abilities, AUTH_ACTIONS.MENU, item.authSubject)) return;

    if (item.children?.length > 0) {
      return (
        <SubMenu key={item.name} title={item.name}>
          {item.children.map((subItem, subItemIdx) =>
            renderMenuItem(subItem, path + item.path)
          )}
        </SubMenu>
      );
    } else {
      return (
        <Menu.Item key={item.name}>
          <Link to={path + item.path}>{item.name}</Link>
        </Menu.Item>
      );
    }
  };

  return (
    <Menu
      mode="inline"
      onClick={() => {
        if (onCollapseSider) onCollapseSider();
      }}
    >
      {routes.map((item) => renderMenuItem(item, path))}
    </Menu>
  );
}
